import { MenuKey } from '@/interfaces';
import { PRIVATE_ROUTES } from '@/routes';
import { useGetRoutesWithPermissions } from '@/routes/useGetRoutesWithPermissions';
import { Icon } from '@amili-v3/amili-v3-design';
import { icons } from '@amili-v3/amili-v3-design/src/icons/components';
import classNames from 'classnames';
import { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles.scss';

type MobileItems = {
  icon: keyof typeof icons;
  label: string;
  href: string;
  menuKey: MenuKey;
};

const mobileItems: MobileItems[] = [
  {
    icon: 'home',
    label: 'Home',
    href: PRIVATE_ROUTES.PROFILE.ROOT,
    menuKey: 'PROFILE',
  },
  {
    icon: 'backet',
    label: 'Orders',
    href: PRIVATE_ROUTES.ORDER.ROOT,
    menuKey: 'ORDER',
  },
];

const MobileHeader = () => {
  const navigate = useNavigate();
  const { permissions } = useGetRoutesWithPermissions();

  const { pathname } = useLocation();

  return (
    <div className="mobile-header">
      {mobileItems
        .filter(item => permissions[item.menuKey])
        .map(item => (
          <div
            key={item.href}
            className={classNames('mobile-header-item', {
              active: pathname.includes(item.href),
            })}
            onClick={() => navigate(item.href)}
          >
            <Icon name={item.icon} width={14} />
            {item.label}
          </div>
        ))}
    </div>
  );
};

export default memo(MobileHeader);
